module.exports = __webpack_public_path__ + "static/media/bacalhau-salgado.6a848422.jpg";